<template>
    <div class="preloader" v-show="loader">
        <div class="lds-ellipsis">
            <span></span>
            <span></span>
            <span></span>
        </div>
    </div>
</template>

<script>

    import tools from '../config.ts';

    export default {
        name: "Loader",
        data() {
            return {
                loader:false,
            }
        },

        mounted() {

            tools.$on("loader", (active) => {
                this.loader = active
            });
        }
    }
</script>